import React, { useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography } from "@mui/material";

const HoverImageCard = ({ imageSrc, title, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      sx={{
        position: "relative",
        width: "350px",
        height: "350px",
        overflow: "hidden",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image */}
      <motion.img
        src={imageSrc}
        alt={title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "8px",
        }}
        whileHover={{ scale: 1.1 }}
        transition={{ duration: 0.5 }}
      />

      {/* Title & Description Container */}
      <motion.div
        initial={{ bottom: 0 }}
        animate={{ bottom: isHovered ? "3px" : "0px" }}
        transition={{ duration: 0.5 }}
        style={{
          position: "absolute",
          left: 0,
          width: "100%",
          background: "linear-gradient(286.74deg, rgba(0, 0, 0, 0.79) 0%, rgba(0, 0, 0, 0) 124.59%)",
          color: "white",
          padding: "16px",
        }}
      >
        {/* Title */}
        <Typography variant="h6" sx={{ fontWeight: "bold", transition: "0.5s" }}>
          {title}
        </Typography>

        {/* Description (Appears on Hover) */}
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="body2">{description}</Typography>
          </motion.div>
        )}
      </motion.div>
    </Box>
  );
};

export default HoverImageCard;
